import { render, staticRenderFns } from "./LargeAmountConfirm.vue?vue&type=template&id=d9f75608&scoped=true&"
import script from "./LargeAmountConfirm.vue?vue&type=script&lang=js&"
export * from "./LargeAmountConfirm.vue?vue&type=script&lang=js&"
import style0 from "./LargeAmountConfirm.vue?vue&type=style&index=0&id=d9f75608&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9f75608",
  null
  
)

export default component.exports